export { FontSize } from "@tiptap/extension-text-style";
